import BillingInfoIcon from "public/cyber-security/edrmdrxdr/stash_billing-info.svg";
import SupportIcon from "public/cyber-security/edrmdrxdr/material-symbols_support.svg";
import RefreshIcon from "public/cyber-security/edrmdrxdr/charm_refresh.svg";
import ComplianceIcon from "public/cyber-security/edrmdrxdr/grommet-icons_compliance.svg";
import CubeImg from "public/cyber-security/edrmdrxdr/bxs_cube.svg";
import AnalyticsIcon from "public/cyber-security/edrmdrxdr/mdi_google-analytics.svg";

export const WHY_ONEMIND_CONSTANTS = {
  TITLE: "Why Security Teams Choose OneMind for Patch & Vulnerability Management  ",
  ITEMS: [
    {
      image: AnalyticsIcon,
      title: "Identify & Fix Security Weaknesses Automatically",
      content:
        "AI-driven scanning detects unpatched software, misconfigurations, and risky applications — before attackers do.",
    },
    {
      image: CubeImg,
      title: "Ensure Compliance with Industry Standards",
      content:
        "Meet security mandates like SOC 2, PCI-DSS, and NIST with audit-ready reporting and continuous posture visibility.",
    },
    {
      image: ComplianceIcon,
      title: "Prevent Ransomware & Exploits",
      content:
        "Patch zero-day vulnerabilities before they’re weaponized — and stop threats before they execute.",
    },
    {
      image: RefreshIcon,
      title: "Reduce IT Workload with Automated Patching",
      content:
        "Eliminate manual patching delays with fully automated workflows for OS and third-party applications.",
    },
    {
      image: SupportIcon,
      title: "Prioritize Risks with AI-Powered Analytics",
      content:
        "Focus on what matters — rank vulnerabilities by exploitability and business impact.",
    },
    {
      image: BillingInfoIcon,
      title: "Seamless Patching Without Downtime",
      content:
        "Ensure uninterrupted operations with zero-touch patching and automated rollback protection.",
    },
  ],
};
